import {Box} from '@logistics-frontend/blocks'
import {Image} from '@logistics-frontend/blocks/image'
import {tag2url} from '@logistics-frontend/utils'
import React from 'react'

import {TagLineWidgetConfig} from '../types'
import {Tag} from './components/Tag'
import * as classes from './TagLine.classes'

export const TagLineWidget = ({tags}: TagLineWidgetConfig): React.ReactElement => {
  return (
    <Box flexDirection="row" flexWrap="wrap" gap="xs">
      {tags.map(({action, icon, text}) => (
        <Tag action={action}>
          {text}
          {icon && <Image alt="" className={classes.inlineImage} height={20} src={tag2url(icon.image_tag)} />}
        </Tag>
      ))}
    </Box>
  )
}
